// extracted by mini-css-extract-plugin
module.exports = {"errorMessageBox":"VIP_Error__errorMessageBox","errorMessagePaper":"VIP_Error__errorMessagePaper","message":"VIP_Error__message"};